import React from "react";
import './SortArrow.css'
const SortArrow = ({ direction }) => {
  return (
    <span className="sort-arrow">
      {/* Стрелка вверх */}
      <i
        className={`sort-arrow__caret sort-arrow__caret_up ${
          direction === "asc" ? "active" : ""
        }`}
      ></i>
      {/* Стрелка вниз */}
      <i
        className={`sort-arrow__caret sort-arrow__caret_down ${
          direction === "desc" ? "active" : ""
        }`}
      ></i>
    </span>
  );
};

export default SortArrow;